// extracted by mini-css-extract-plugin
export default {"ActionCompetenceBadge":"ActionCompetenceBadge_ActionCompetenceBadge__kXl6H"};